import styled from '@emotion/styled'
import { css } from '@emotion/react'

const containerStyles = ({ theme }) => css`
  label: container;

  padding-bottom: ${theme.spacings.byte};
  padding-top: ${theme.spacings.byte};
`
export const Container = styled('div')(containerStyles)

export const baseStyles = ({ theme }) => css`
  label: base;

  padding: ${theme.spacings.byte} ${theme.spacings.mega};
  box-sizing: border-box;
  border: 1px solid ${theme.colors.n100};
  border-radius: ${theme.borderRadius.tera};
  background: ${theme.colors.white};
  box-shadow: 0 0 10px ${theme.colors.n100};
  height: 300px;
  transition: border-color ease 300ms;
  width: 150px;

  ${theme.media.giga} {
    width: 172px;
  }
`

const baseActiveStyles = ({ theme, isActive }) =>
  isActive &&
  css`
    label: base__active;

    border-color: transparent;
    background-image: linear-gradient(156deg, #9a21aa 0%, #7808cf 100%);
    ${IconExtra} svg {
      color: ${theme.colors.f700};
    }
    ${IconReceived} svg {
      color: ${theme.colors.white};
    }
    ${IconGift} svg {
      color: ${theme.colors.f600};
    }
    ${IconShare} svg {
      color: ${theme.colors.white};
    }
    ${Picture} {
      border-color: ${theme.colors.f500};
    }
    ${PictureImage} svg {
      color: ${theme.colors.white};
      fill: ${theme.colors.white};
    }
    ${PictureIcon} {
      color: ${theme.colors.f200};
      background: ${theme.colors.f500};
      border: none;
    }
    ${Title} {
      color: ${theme.colors.white};
    }
    ${Description} {
      color: ${theme.colors.f400};
    }
    ${Divider} {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23D095F1' viewBox='0 0 12 2'%3E%3Crect width='8' height='2' x='2' rx='1'/%3E%3C/svg%3E%0A");
      &:before,
      &:after {
        border-color: ${theme.colors.white};
      }
    }
    ${TextFooter} {
      color: ${theme.colors.f400};
      font-weight: ${theme.font.weight.mega};
    }
    ${Bottom} button {
      background: transparent;
      color: ${theme.colors.f400};
    }
  `

export const Wrapper = styled('div')(baseStyles, baseActiveStyles)

const iconExtraStyles = ({ theme }) => css`
  label: icon__extra;

  position: absolute;
  top: ${theme.spacings.byte};
  right: 7px;
`
export const IconExtra = styled('div')(iconExtraStyles)

const iconReceivedStyles = ({ theme }) => css`
  label: icon__received;

  position: absolute;
  right: 7px;

  svg {
    color: ${theme.colors.f600};
  }
`

export const IconReceived = styled('div')(iconReceivedStyles)

const iconGiftStyles = ({ theme }) => css`
  label: icon__gift;

  position: relative;
  left: -7px;

  svg {
    width: 14px;
    height: 14px;
    color: ${theme.colors.white};
    pointer-events: none;
  }
`

export const IconGift = styled('div')(iconGiftStyles)

const iconShareStyles = ({ theme }) => css`
  label: icon__share;

  cursor: pointer;

  svg {
    color: ${theme.colors.f600};
  }
`

export const IconShare = styled('div')(iconShareStyles)

const groupDescriptionStyles = () => css`
  label: icon__description;

  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: space-around;
  height: 190px;
`

export const GroupDescription = styled('div')(groupDescriptionStyles)

const pictureStyles = ({ theme }) => css`
  label: picture;

  position: relative;
  width: 84px;
  height: 84px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 3px solid ${theme.colors.n100};
  border-radius: ${theme.borderRadius.circle};
  cursor: pointer;
`

export const Picture = styled('div')(pictureStyles)

const pictureImageStyles = ({ theme }) => css`
  label: picture__image;

  img,
  svg {
    display: block;
    width: 100%;
    height: 100%;
  }
  img {
    border-radius: ${theme.borderRadius.circle};
  }
  svg {
    padding: 10px;
    color: ${theme.colors.v700};
    fill: ${theme.colors.v700};
  }
`
export const PictureImage = styled('div')(pictureImageStyles)

const pictureIconStyles = ({ theme }) => css`
  label: picture__icon;

  position: absolute;
  left: 0;
  bottom: 0;
  width: 29px;
  height: 29px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${theme.colors.n300};
  border-radius: ${theme.borderRadius.circle};
  border: 3px solid ${theme.colors.n100};
  background: ${theme.colors.white};
  transition: background ease-in 300ms;
`
export const PictureIcon = styled('div')(pictureIconStyles)

const titleStyles = ({ theme }) => css`
  label: title;

  margin-top: ${theme.spacings.bit};

  p {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    font-weight: 600;
  }
`
export const Title = styled('div')(titleStyles)

const descriptionStyles = ({ theme }) => css`
  label: description;

  color: ${theme.colors.n400};

  p {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
`

export const Description = styled('div')(descriptionStyles)

const dividerStyles = ({ theme }) => css`
  label: divider;

  position: relative;
  width: calc(100% + 36px);
  margin: 0 -18px;
  border-top-style: dotted;
  border-width: 6px;
  border-color: ${theme.colors.n100};

  &::before,
  &::after {
    content: '';
    position: absolute;
    top: -15px;
    width: 20px;
    border-radius: 50%;
    height: 23px;
    background: ${theme.colors.background};
  }
  &:before {
    left: -7px;
  }
  &:after {
    right: -7px;
  }
  path {
    stroke: ${theme.colors.n100};
  }
`

export const Divider = styled('div')(dividerStyles)

const bottomStyles = () => css`
  label: bottom;

  display: flex;
  align-items: center;
  flex-direction: column;
  height: 95px;
  justify-content: space-evenly;
  width: 100%;
`

export const Bottom = styled('div')(bottomStyles)

const textFooterStyles = ({ theme }) => css`
  label: text__footer;

  svg {
    position: relative;
    margin-right: ${theme.spacings.bit};
    top: 1px;
  }
`
export const TextFooter = styled(Description)(textFooterStyles)

const buttonIconStyles = ({ theme }) => css`
  label: button__icon;

  svg {
    margin-right: ${theme.spacings.byte};
  }
`
export const ButtonIcon = styled('div')(buttonIconStyles)
